import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Welcome Inn. All rights reserved. | Contact: (912) 275-5000 | Email: welcomeinn1921@gmail.com</p>
    </footer>
  );
}

export default Footer;
